
import { Vue, Component } from 'vue-property-decorator';
import Container from '@/components/Container.vue';

@Component({
  components: { Container }
})
export default class JTMSPayments extends Vue {}
